import { DishFirstExploreWidthLimit } from 'src/pages/consumer/dish-first/explore/components/SharedStyles';
import { PrimaryButton, SecondaryButton } from 'src/shared/design-system/Buttons';
import styled from 'styled-components';
import { Spacing } from 'web-common/src/shared/styles';
import { BorderRadius } from 'web-common/src/shared/styles/border';
import { FontSize, FontWeight } from 'web-common/src/shared/styles/font';
import { ScreenWidth } from 'web-common/src/shared/styles/screenWidth';

const buttonText = 'See All Cuisines';

const BrowseAllShefsButtonDesktop = styled(PrimaryButton)`
  font-weight: ${FontWeight.SEMI_BOLD};
  border-radius: ${BorderRadius.M};
  font-size: ${FontSize.S};
  height: ${Spacing.TRIPLE};
  width: 148px;
  padding: 0px 0px;
`;

const BrowseAllShefsButtonMobile = styled(SecondaryButton)`
  font-weight: ${FontWeight.SEMI_BOLD};
  border-radius: ${BorderRadius.M};
  font-size: ${FontSize.S};
  height: ${Spacing.TRIPLE};
  width: 100%;
`;

const breakpoint = ScreenWidth.SMALL;

const BrowseAllShefsButtonContainer = styled(DishFirstExploreWidthLimit)`
  padding: ${Spacing.DOUBLE} ${Spacing.SINGLE};
  justify-content: center;
  display: flex;

  @media (min-width: ${breakpoint}) {
    ${BrowseAllShefsButtonMobile} {
      display: none;
    }
  }

  @media (max-width: ${breakpoint}) {
    ${BrowseAllShefsButtonDesktop} {
      display: none;
    }
  }
`;

export const BrowseAllShefsSection = ({ onClick }: { onClick: () => void }): JSX.Element => (
  <>
    <BrowseAllShefsButtonContainer>
      <BrowseAllShefsButtonDesktop onClick={onClick}>{buttonText}</BrowseAllShefsButtonDesktop>
      <BrowseAllShefsButtonMobile onClick={onClick}>{buttonText}</BrowseAllShefsButtonMobile>
    </BrowseAllShefsButtonContainer>
  </>
);
